import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import { Heading, Section } from 'components/Layout';
import AvatarSelect from 'components/ui/AvatarSelect';
import DatePicker from 'components/ui/DatePicker';
import Select from 'components/ui/Select';
import TextField from 'components/ui/TextField';
import cx from 'utils/cx';

export const SelectForm = (props) => (
  <GenericForm component={Select} {...props} />
);
export const TextFieldForm = (props) => (
  <GenericForm component={TextField} {...props} />
);
export const DatePickerForm = (props) => (
  <GenericForm component={DatePicker} {...props} />
);
export const AvatarSelectForm = (props) => (
  <GenericForm component={AvatarSelect} {...props} />
);

const GenericForm = forwardRef(
  (
    { title, required, subTitle, className, component, children, ...rest },
    ref,
  ) => {
    const Component = component;
    return (
      <Section className={cx(className, 'sm-padding')}>
        {title && (
          <Heading className="form-sec-title" ref={ref}>
            <span className={cx({ required })}>{title}</span>
            {subTitle && <span className="form-sec-sub-title">{subTitle}</span>}
          </Heading>
        )}
        {children || <Component {...rest} required={required} />}
      </Section>
    );
  },
);

GenericForm.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  required: PropTypes.bool,
  component: PropTypes.any,
  children: PropTypes.node,
};

GenericForm.defaultProps = {
  className: null,
  component: null,
  title: '',
  subTitle: '',
  required: false,
  children: null,
};

export default GenericForm;
